require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-12-calendar-feed.json") })
        }
      }, "path---article-12-calendar-feed");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-12-calendar-feed!./.cache/json/article-12-calendar-feed.json
// module id = 476
// module chunks = 231608221292675